import React from 'react';
import {
  StepOneType,
  TimedOutType,
  StepOneContentType,
  StepTwoType,
  BottomSectionType,
} from 'cards/components/common/modals/Digital/ShareStepModals/types';
import cx from 'classnames';
import { ButtonV2 } from '@zola/zola-ui/src/components/Button';
import { CircleIcon } from '@zola/zola-ui/src/components/CircleIcon';
import { LightBulb2 } from '@zola/zola-ui/src/assets/images/icons';

import iconX from 'assets/images/icons/iconX.svg';

import styles from 'cards/components/common/modals/Digital/ShareStepModals/ShareModalUI.module.less';

export const TimedOut = ({ imageRenderLoop }: TimedOutType): JSX.Element => (
  <>
    <div>
      <h2 className={styles.stepTitle}>Looks like you might need to retry</h2>
      <div className={styles.stepContent}>
        <div className={cx(styles.stepText, styles.errorText)}>
          It&apos;s taking a bit longer than expected, please retry!
        </div>
      </div>
    </div>
    <ButtonV2 className={styles.buttonFail} onClick={imageRenderLoop}>
      Retry
    </ButtonV2>
  </>
);

export const RenderFail = ({ hideModal }: { hideModal: () => void }): JSX.Element => (
  <>
    <div>
      <h2 className={styles.stepTitle}>Oops! There was a problem rendering your project.</h2>
    </div>
    <ButtonV2 onClick={hideModal}>Try later</ButtonV2>
  </>
);

export const BottomSection = ({
  mediaFileUrl,
  handleButtonClick,
  textButton,
}: BottomSectionType): JSX.Element => {
  return (
    <div className={styles.modalBottom}>
      <ButtonV2
        style={{ position: 'relative' }}
        disabled={!mediaFileUrl}
        onClick={() => handleButtonClick(mediaFileUrl)}
      >
        {textButton}
      </ButtonV2>
    </div>
  );
};

// @ts-ignore
const leftColumnData: [] = new Array(7);
// @ts-ignore
const rightColumnData: [] = new Array(9);
const renderLineElements = (data: []) =>
  [...data].map((e, i) => <span key={i} className={styles.textMessage} />);

export const StepOneContent = ({
  percentComplete,
  cancelRequest,
}: StepOneContentType): JSX.Element => {
  return (
    <div className={cx(styles.stepOneWrapper, {})}>
      <span className={styles.stepOneTitle}>
        {/* eslint-disable-next-line jsx-a11y/accessible-emoji */}
        Working some magic <span role="img">🔮</span>
      </span>
      <span className={styles.stepOneSubTitle}>This could take a few seconds.</span>
      <div className={styles.progressWrapper}>
        <div className={styles.infoWrapper}>
          <div className={styles.progressInfo}>
            <span className={styles.progressTitle}>Generating your image</span>
            <span className={styles.progressPercentage}>{`${percentComplete}%`}</span>
          </div>
          <div className={styles.progressBar}>
            <div style={{ width: `${percentComplete}%` }} className={styles.progressInner} />
          </div>
        </div>
        {percentComplete !== 100 && (
          <button type="button" className={styles.progressClose} onClick={cancelRequest}>
            <img alt="" src={iconX} />
          </button>
        )}
      </div>
    </div>
  );
};

export const StepTwoContent = ({
  previewComponent,
  activeStep,
}: {
  previewComponent: () => void;
  activeStep: string | undefined;
}): JSX.Element => {
  return (
    <div className={styles.stepTwoContent}>
      <div className={styles.topContent}>
        <CircleIcon className={styles.bulbIcon} image={LightBulb2} size={100} variant="cream" />
        <div className={styles.previewWrapper}>
          <div className={styles.previewHeader}>
            <div className={styles.searchBar} />
            <div className={styles.zolaIcon} />
          </div>
          <div className={styles.downloadModalContent}>
            <div className={styles.columnLeft}>{renderLineElements(leftColumnData)}</div>
            <div className={styles.columnRight}>
              {renderLineElements(rightColumnData)}
              {previewComponent()}
              <span className={styles.likeButton} />
            </div>
          </div>
        </div>
      </div>
      <div className={styles.textWrapper}>
        <h1 className={styles.titleText}>{activeStep && 'Copied! '}Now what?</h1>
        <ul className={styles.instructionList}>
          <li>
            <span>Start a new email, text, or DM and write a special note to guests</span>
          </li>
          <li>
            <span>Download and attach the image of your save the date</span>
          </li>
          <li>
            <span>{activeStep ? 'Paste' : 'Copy and paste'} this URL into the message</span>
          </li>
          <li>
            <span>Send!</span>
          </li>
        </ul>
        <span className={styles.textTips}>
          Pro Tip: No need for multiple emails! Write a single email and enter all email addresses
          into the BCC line, instead. It&apos;s easy, and guests won&apos;t be able to see the other
          recipients.
        </span>
      </div>
    </div>
  );
};

export const StepOne = ({
  mediaFileUrl,
  percentComplete,
  handleButtonClick,
  cancelRequest,
}: StepOneType): JSX.Element => (
  <>
    <StepOneContent percentComplete={percentComplete} cancelRequest={cancelRequest} />
    <BottomSection
      textButton="Ready"
      handleButtonClick={handleButtonClick}
      mediaFileUrl={mediaFileUrl}
    />
  </>
);

export const StepTwo = ({
  previewComponent,
  mediaFileUrl,
  handleButtonClick,
  activeStep,
}: StepTwoType): JSX.Element => {
  return (
    <>
      <StepTwoContent previewComponent={previewComponent} activeStep={activeStep} />
      <BottomSection
        textButton={activeStep ? 'Got it' : 'Done'}
        handleButtonClick={handleButtonClick}
        mediaFileUrl={mediaFileUrl}
      />
    </>
  );
};
